import { createBrowserHistory } from 'history';
export const browserHistoryInstance = createBrowserHistory();